import PropTypes from 'prop-types';
import React from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import VerifyPhone from 'assets/illustrations/Phone-and-Smile.svg';

const CreateAndVerifyPhoneForIdentityVerification = () => {
  return (
    <Box display='flex' flexDirection='column' alignItems='center' width='100%' sx={{ textAlign: 'center' }}>
      <Typography>Before starting, add your phone number to Simplifi.</Typography>
      <Box display='flex' alignItems='center' mt={2} mb={2}>
        <img src={VerifyPhone} alt='phone-check' />
      </Box>
      <Box mt={5} px={4} width={700}>
        <Typography variant='paragraphRegular' component='span' color='textSecondary'>
          You&apos;ll be taken to My Account to add your phone number. Once finished, close My Account and return here
          to automatically continue.&nbsp;
        </Typography>
      </Box>
    </Box>
  );
};
CreateAndVerifyPhoneForIdentityVerification.propTypes = {
  phoneNumber: PropTypes.string,
};

export default CreateAndVerifyPhoneForIdentityVerification;
